<template>
  <div class="job-benefits-screen">
    <VideoOrImage
      class="job-benefits-screen__background"
      :src="backgroundUri || CAREER_BENEFITS_SCREEN_DEFAULTS.backgroundUri"
    />
    <div class="job-benefits-screen__content container">
      <ScreenHeader class="job-benefits-screen__header" data-aos="fade-down">
        <template #title> {{ title || CAREER_BENEFITS_SCREEN_DEFAULTS.title }} </template>
        <!--        <template #text>-->
        <!--          Level Up Your Professional Journey With Us!-->
        <!--        </template>-->
      </ScreenHeader>
      <div class="job-benefits-screen__benefits">
        <div
          class="job-benefit job-benefits-screen__benefit"
          v-for="(benefit, i) in benefits"
          :key="benefit.label"
          data-aos="fade-up"
          :data-aos-delay="i * 300"
          data-aos-offset="-200"
        >
          <i class="job-benefit__icon fa-solid" :class="[benefit.icon]" />
          <p class="job-benefit__title">{{ benefit.label }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  const CAREER_BENEFITS_SCREEN_DEFAULTS = {
    title: "Why Work At Speedway Games?",
    backgroundUri: "/screen-bg-1.webp",
  }

  const props = defineProps<{
    title?: string;
    subtitle?: string;
    description?: string;
    benefits: { icon: string; label: string }[];
    backgroundUri?: string;
  }>();
</script>

<style lang="scss">
  .job-benefits-screen {
    background-color: #182656;
    background-size: cover;
    background-position: center;

    position: relative;

    padding: 128px 0;

    &__background {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;

      opacity: 0.2;
    }

    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 64px;

      @media (max-width: $md) {
        gap: 32px;
      }
    }

    &__header {
      max-width: 512px;

      * {
        color: white;
      }
    }

    &__benefits {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      gap: 128px;

      width: 100%;

      @media (max-width: $md) {
        justify-content: center;
        gap: 32px;
      }
    }

    &__benefit {
      flex: 1 0 256px;
    }
  }

  .job-benefit {
    display: flex;
    flex-direction: column;
    gap: 16px;

    text-align: center;
    color: white;

    &__icon {
      font-size: 96px;
    }

    &__title {
      font-family: var(--font-family-main);
      font-size: 24px;
      font-weight: 400;
    }

    transition: transform 200ms ease-out;
    &:hover {
      transform: scale(1.05);
    }
  }
</style>
